module.exports = __webpack_public_path__ + "img/AFAM.21886be7.jpg";